import { motion, useReducedMotion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { GlassButton } from '@/components/ui/glass-button'
import { hero } from '@features/landing/content'
import { TrustBar } from '@shared/TrustBar'

export function Hero() {
  const reduceMotion = useReducedMotion()

  return (
    <section className="mx-auto max-w-6xl px-4 pb-16 pt-20 sm:pt-28">
      <motion.div
        initial={reduceMotion ? false : { opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="mx-auto max-w-3xl text-center"
      >
        <p className="mb-5 inline-flex rounded-full border border-black/10 bg-white/50 px-4 py-1.5 text-xs font-semibold uppercase tracking-wider text-blue-700 backdrop-blur-xl dark:border-white/[0.08] dark:bg-white/[0.08] dark:text-blue-300">
          {hero.eyebrow}
        </p>

        <h1 className="text-balance text-4xl font-extrabold leading-tight tracking-tight text-foreground sm:text-5xl md:text-6xl">
          {hero.title}
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-pretty text-lg leading-relaxed text-muted-foreground">
          {hero.subtitle}
        </p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <GlassButton variant="primary" size="lg" asChild>
            <a href={hero.primaryCta.href}>
              {hero.primaryCta.label}
              <ArrowRight />
            </a>
          </GlassButton>
          <GlassButton variant="outline" size="lg" asChild>
            <a href={hero.secondaryCta.href}>{hero.secondaryCta.label}</a>
          </GlassButton>
        </div>
      </motion.div>

      <motion.dl
        initial={reduceMotion ? false : { opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.15, ease: 'easeOut' }}
        className="mx-auto mt-16 grid max-w-3xl grid-cols-1 gap-4 sm:grid-cols-3"
      >
        {hero.stats.map((stat) => (
          <div
            key={stat.label}
            className="rounded-2xl border border-black/10 bg-white/45 px-5 py-6 text-center backdrop-blur-xl dark:border-white/[0.08] dark:bg-white/[0.10]"
          >
            <dt className="sr-only">{stat.label}</dt>
            <dd>
              <span className="block bg-linear-to-r from-cyan-600 via-blue-600 to-purple-600 bg-clip-text text-3xl font-bold text-transparent dark:from-cyan-300 dark:via-blue-300 dark:to-purple-300">
                {stat.value}
              </span>
              <span className="mt-1 block text-sm text-muted-foreground">{stat.label}</span>
            </dd>
          </div>
        ))}
      </motion.dl>

      <TrustBar className="mt-12" delay={0.3} />
    </section>
  )
}
